import { render, staticRenderFns } from "./CustomerCardDialog.vue?vue&type=template&id=5068b04a&scoped=true"
import script from "./CustomerCardDialog.vue?vue&type=script&lang=ts"
export * from "./CustomerCardDialog.vue?vue&type=script&lang=ts"
import style0 from "./CustomerCardDialog.vue?vue&type=style&index=0&id=5068b04a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5068b04a",
  null
  
)

export default component.exports